<filter-expandable [filter]="filter"
  [isDefault]="isDefault">

  <div class="p2 m-t-6">
    <price [value]="rangeMin"></price>&nbsp;-&nbsp;<price [value]="rangeMax"></price>
  </div>


  @if (filter) {
    <range-slider class="m-t-6 m-b-8"
      [value]="rangeMin"
      [highValue]="rangeMax"
      [options]="options"
      (userChange)="onUserChange($event)"
    (userChangeEnd)="onUserChangeEnd($event)"></range-slider>
  }
</filter-expandable>